// BKW custom build —> production.
// Selected via `ng build --configuration bkw` (see angular.json).

import { baseUrls } from './base-urls'

export const environment = {
  production: true,
  baseUrl: 'https://gateway-web.bkw.eloaded.eu',
  ...baseUrls,
  chargingWeb: {
    ...baseUrls.chargingWeb,
    baseUrl: 'https://public.bkw.eloaded.eu'
  }
}
